/**
 * Tiny telemetry helper — fire-and-forget POST to /api/events.
 * Never blocks or throws to callers (best-effort logging).
 */
import { trackEvent } from "./api";

const CLIENT_ID_KEY = "shutterkart_client_id";

function _ensureClientId() {
  if (typeof window === "undefined") return null;
  let id = window.localStorage.getItem(CLIENT_ID_KEY);
  if (!id) {
    id =
      (window.crypto && window.crypto.randomUUID && window.crypto.randomUUID()) ||
      `c_${Math.random().toString(36).slice(2)}_${Date.now()}`;
    window.localStorage.setItem(CLIENT_ID_KEY, id);
  }
  return id;
}

export function getClientId() {
  return _ensureClientId();
}

export function track(event, { properties, draftId } = {}) {
  try {
    const clientId = _ensureClientId();
    trackEvent({
      event,
      properties: properties || {},
      anonymous_client_id: clientId,
      draft_id: draftId || null,
    }).catch(() => {
      /* swallow */
    });
  } catch {
    /* never throw */
  }
}

/**
 * Debounced wrapper. Fires the same event at most once per `wait` ms.
 */
export function debouncedTrack(wait = 1000) {
  let timer = null;
  let lastArgs = null;
  return (event, args) => {
    lastArgs = { event, args };
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      track(lastArgs.event, lastArgs.args || {});
      timer = null;
      lastArgs = null;
    }, wait);
  };
}
